/** Zone keys per app layout (V2). */
export const STUDIO_V2_LAYOUT_ZONES = {
  'three-panel': ['left', 'center', 'right'],
  'two-panel': ['left', 'right'],
  dynamic: ['main'],
  grid: ['grid'],
};

/** Common panel binding paths when flow definition has no inspectable state. */
export const COMMON_OUTPUT_PATH_HINTS = [
  'result',
  'data',
  'output',
  'items',
  'rows',
  'messages',
  'content',
];

export { APP_BINDING_SOURCE_HINTS } from '../../utils/interviewFlowRuntime.js';

/**
 * Derive suggested JSON-ish paths from a flow definition (state keys, metadata, node ids).
 * @param {object} definition
 * @returns {string[]}
 */
export function sortPanelsByOrder(panels) {
  return [...(panels || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function collectOutputPathHints(definition) {
  const hints = new Set(COMMON_OUTPUT_PATH_HINTS);
  if (!definition || typeof definition !== 'object') return [...hints];

  const { state, metadata, nodes } = definition;
  if (state && typeof state === 'object' && !Array.isArray(state)) {
    Object.keys(state).forEach((k) => hints.add(k));
  }
  if (metadata && typeof metadata === 'object' && !Array.isArray(metadata)) {
    Object.keys(metadata).forEach((k) => hints.add(`metadata.${k}`));
    const declared = metadata.outputPathHints;
    if (Array.isArray(declared)) {
      declared.forEach((p) => {
        const s = String(p || '').trim();
        if (s) hints.add(s);
      });
    }
  }
  if (Array.isArray(nodes)) {
    nodes.forEach((n) => {
      if (n?.id) hints.add(`nodes.${n.id}`);
    });
  }

  return [...hints].slice(0, 48);
}
